/* RESPONSIBLE TEAM: team-email */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class CsvUpdateRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(CsvUpdateRoute);
